import React from "react";

const ZIcon = ({ style, height }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 66 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2136_23129)">
      <rect
        x="2.29639"
        y="0.589355"
        width="63.3704"
        height="59"
        rx="7.18683"
        fill="#EFF1F5"
      />
      <rect
        x="2.92523"
        y="1.2182"
        width="62.1127"
        height="57.7423"
        rx="6.55798"
        stroke="#212326"
        strokeWidth="1.2577"
      />
    </g>
    <path
      d="M18.5477 33.7004V31.1678L26.9137 21.0373L26.9552 21.4732L26.3324 20.6429L26.7476 20.975H18.7968V18.5462H30.1729V21.0788L21.7861 31.1886L21.7239 30.7111L22.4089 31.6453L21.9107 31.2716H30.2767V33.7004H18.5477Z"
      fill="#42464C"
    />
    <defs>
      <filter
        id="filter0_d_2136_23129"
        x="0.176757"
        y="0.589355"
        width="65.49"
        height="63.3704"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.11963" dy="4.37037" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.27451 0 0 0 0 0.298039 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2136_23129"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2136_23129"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default ZIcon;
